import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49a397c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "countrybox" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "pricing" }, "Select your preferred country:", -1))
const _hoisted_3 = { class: "switch-field" }
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  class: "col-12 p-0",
  id: "dropdownbox"
}
const _hoisted_7 = {
  class: "nice-select selectortypes",
  tabindex: "0"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "current" }, [
    /*#__PURE__*/_createElementVNode("img", { src: "https://cdn.proxyscrape.com/img/country/mixed.png" }),
    /*#__PURE__*/_createTextVNode("Mixed")
  ])
], -1))
const _hoisted_9 = { class: "list countryselect" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://docs.google.com/forms/d/e/1FAIpQLSfv8Vio7r8qoW1UcRByEyYwInchoXZ9MG0W0rO034YC_Y6K_g/viewform?usp=sf_link",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "option" }, "Other")
], -1))

import { getData } from '@/composables/premium-proxies';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const cards = getData();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cards), (card, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "option selected",
                    key: index,
                    "data-value": "{{card.information.abr}}",
                    onClick: ($event: any) => (_unref(getData)(card.information.abr))
                  }, [
                    _createElementVNode("img", {
                      src: card.information.icon
                    }, null, 8, _hoisted_11),
                    _createTextVNode(_toDisplayString(card.information.name), 1)
                  ], 8, _hoisted_10))
                }), 128)),
                _hoisted_12
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})